export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
at({ "en": { "referenceResolversLite": { "owners": { "deactivatedOwner": "(Deactivated/Removed)", "salesforceOwner": "(Salesforce)" }, "conversationInbox": { "archived": "(Archived)" } } } });
};